export type MDMAUnifiedStatus =
  | 'Settlement In Progress'
  | 'Settlement Failed'
  | 'Generating Reports'
  | 'Report Generation Failed'
  | 'Settlement Generated'
  | 'Publishing'
  | 'Publishing Failed'
  | 'Published'
  | 'Submitting'
  | 'Submission Failed'
  | 'Submitted'
  | 'Rejected'
  | 'Cancelled'
  | 'Unknown'
  | 'Settlement Complete'

export const MDMAUnifiedStatus: Readonly<Record<string, MDMAUnifiedStatus>> = {
  SETTLEMENT_IN_PROGRESS: 'Settlement In Progress',
  SETTLEMENT_FAILED: 'Settlement Failed',
  GENERATING_REPORTS: 'Generating Reports',
  REPORT_GENERATION_FAILED: 'Report Generation Failed',
  SETTLEMENT_GENERATED: 'Settlement Generated',
  PUBLISHING: 'Publishing',
  PUBLISHING_FAILED: 'Publishing Failed',
  PUBLISHED: 'Published',
  SUBMITTING: 'Submitting',
  SUBMISSION_FAILED: 'Submission Failed',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  UNKNOWN: 'Unknown',
  SETTLEMENT_COMPLETE: 'Settlement Complete',
} as const

export type MDMAJobStatus = Readonly<{
  run_instance_uid: string
  start_time: Date
  end_time: Date
  operating_date: Date
  has_similar_published_runs: boolean
  is_published: boolean | null
  is_submitted: boolean | null
  run_type_name: string
  settlement_type_code: string
  status_code: string
  unified_status_code: MDMAUnifiedStatus
  unified_status_name: MDMAUnifiedStatus
  duration: number
  create_time: Date
  created_by: string | null
}>

export type MDMABestAvailable = Readonly<{
  run_instance_uid: string
  operating_day: Date
  settlement_type: string
}>

export type MDMAPreviousRun = Readonly<{
  run_instance_uid: string
  operating_date: Date
  settlement_type: number
  prev_settlement_type_operating_date: Date | null
  prev_settlement_type_settlement_type: number | null
  prev_operating_date_operating_date: Date | null
  prev_operating_date_settlement_type: number | null
  prev_settlement_type_run_instance_uid: string | null
  prev_operating_date_run_instance_uid: string | null
}>
